import { create } from "zustand";

const useChatOpen = create((set) => ({
  isChatOpen: false,
  isChannelId:null,
  isChannel:null,
  channelType:'team',
  setIsChatOpen: (newIsChatOpen) => set(() => ({ isChatOpen: newIsChatOpen })),
  setIsChannelId: (newChannelId) => set(() => ({ isChannelId: newChannelId })),
  setIsChannel: (newChannel) => set(() => ({ isChannel: newChannel })),
  setChannelType: (newchannelType) => set(() => ({ channelType: newchannelType })),
}));

export default useChatOpen;
